import { legacyColors } from '~/legacyTheme';

export const useSxStyles = () => {
  return {
    hr: {
      borderTop: `solid 1px ${legacyColors.grey4}`,
      margin: '15px 0',
    },
  };
};
